import { render, staticRenderFns } from "./SectionBrochureButton.vue?vue&type=template&id=0beb2a5c&"
import script from "./SectionBrochureButton.vue?vue&type=script&lang=js&"
export * from "./SectionBrochureButton.vue?vue&type=script&lang=js&"
import style0 from "./SectionBrochureButton.vue?vue&type=style&index=0&id=0beb2a5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
